import { getAssets, doExchange as doExchangeApi, submitDeposit, submitWithdraw, getTransactions } from '@/api/account'

const state = {
  usdtBalance: 0,
  usdBalance: 0,
  exchangeDir: 'u2d', // u2d | d2u
  exchangeAmount: 0,
  fundRecords: [
    { id: 1, time: '2026-06-10 14:30', typeLabel: 'USDT入金兑换', amount: 500.00, status: '已完成' },
    { id: 2, time: '2026-06-09 09:15', typeLabel: '交易盈亏', amount: 45.60, status: '已结算' }
  ],
  depositRecords: [],
  withdrawRecords: [],
  notices: [
    { id: 1, title: '系统维护通知', time: '2026-06-10', body: '平台将于 6 月 12 日 02:00–06:00 (UTC+8) 进行系统维护，届时交易服务暂停，请提前做好仓位管理。' },
    { id: 2, title: '杠杆调整说明', time: '2026-06-08', body: '自 6 月 15 日起，XAUUSD 默认杠杆由 1:200 调整为 1:100，XAGUSD 维持 1:100 不变。请关注保证金变化。' }
  ],
  totalCommission: 1280.00,
  inviteCount: 10
}

const getters = {
  usdtBalance: s => s.usdtBalance,
  usdBalance: s => s.usdBalance,
  exchangeDir: s => s.exchangeDir,
  exchangeAmount: s => s.exchangeAmount,
  fundRecords: s => s.fundRecords
}

const mutations = {
  SET_BALANCES(state, { usdt, usd }) {
    state.usdtBalance = usdt
    state.usdBalance = usd
  },
  SET_EXCHANGE_DIR(state, dir) {
    state.exchangeDir = dir
  },
  SET_EXCHANGE_AMOUNT(state, amount) {
    state.exchangeAmount = amount
  },
  SET_FUND_RECORDS(state, list) {
    state.fundRecords = list
  }
}

const actions = {
  async fetchBalances({ commit }) {
    try {
      const res = await getAssets()
      const data = res.data || res
      commit('SET_BALANCES', {
        usdt: data.usdtBalance || data.usdt_balance || 0,
        usd: data.usdBalance || data.usd_balance || 0
      })
    } catch {
      // Use defaults
    }
  },

  async doExchange({ dispatch }, { dir, amount }) {
    const fromCurrency = dir === 'usdt2usd' ? 'USDT' : 'USD'
    const toCurrency = dir === 'usdt2usd' ? 'USD' : 'USDT'
    const res = await doExchangeApi({ fromCurrency, toCurrency, amount })
    if (res.code === 200) {
      dispatch('fetchBalances')
      return res
    }
    throw new Error(res.msg || '兑换失败')
  },

  async submitDeposit({ dispatch }, data) {
    const res = await submitDeposit(data)
    dispatch('fetchBalances')
    return res
  },

  async submitWithdraw({ dispatch }, data) {
    const res = await submitWithdraw(data)
    dispatch('fetchBalances')
    return res
  },

  async fetchFundRecords({ commit }, params) {
    try {
      const res = await getTransactions(params)
      const rows = res.data?.rows || res.rows || res.data || []
      commit('SET_FUND_RECORDS', rows)
    } catch {
      commit('SET_FUND_RECORDS', [])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
